import "./about-me.css";

export const AboutMe = () => {
  return (
    <section className="aboutMe">
      <div className="aboutImage">
        <h2>Sobre mim</h2>
        <img
          src="./images/about-picture.png"
          alt="Joseph smiling, positioned a little to the side"
        />
      </div>
      <div className="aboutText">
        <p>
          Sou um desenvolvedor front-end apaixonado e dedicado, atualmente em
          busca de minha primeira oportunidade no mercado de trabalho. Embora eu
          não tenha experiência profissional em tempo integral, estou
          entusiasmado para começar minha carreira e estou constantemente
          aprimorando minhas habilidades e conhecimentos.
        </p>
        <p>
          Eu concluí Análise e Desenvolvimento de Sistemas e adquiri experiência
          em projetos pessoais onde pude desenvolver minhas habilidades em{" "}
          <span>HTML, CSS e JavaScript</span>, incluindo Bootstrap, Git, SASS e
          React.
        </p>
        <p>
          Estou ansioso para aplicar minhas habilidades e conhecimentos para
          ajudar a construir soluções incríveis e entregar valor para os
          usuários finais. Sou um colaborador comprometido, disposto a aprender
          e a trabalhar em equipe para alcançar objetivos desafiadores.
        </p>
      </div>
    </section>
  );
};
